




import axios from "axios";
import { useEffect, useState } from "react";
import { IoMdArrowBack } from "react-icons/io"; // Importing back icon
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const UpdateBrandProfile = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Form data state
  const [formData, setFormData] = useState({
    uname: "",
    email: "",
    city: "",
    country: "",
    about: "",
    shopName: "",
    phone: "",
    address: "",
    instagramUrl: "",
    facebookUrl: "",
    twitterUrl: "",
    description: "",
  });

  // States for images and loading
  const [profileImage, setProfileImage] = useState(null);
  const [backgroundImage, setBackgroundImage] = useState(null);
  const [loadingProfileImage, setLoadingProfileImage] = useState(false); // For profile image loading
  const [loadingBackgroundImage, setLoadingBackgroundImage] = useState(false); // For background image loading
  const [submitting, setSubmitting] = useState(false); // For form submission

  // Brand ID from localStorage
  const brandId = localStorage.getItem("brandID");

  // On initial load, populate form with location state
  useEffect(() => {
    setFormData(location.state || {});
  }, [location]);

  // Handle form field changes
  const handleChange = (name, value) => {
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  // Handle profile image selection
  const handleProfileImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProfileImage(file);
      uploadProfileImage(file); // Automatically upload the profile image when selected
    }
  };

  // Handle background image selectionddd
  const handleBackgroundImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setBackgroundImage(file);
      uploadBackgroundImage(file); // Automatically upload the background image when selected
    }
  };

  // Function to upload the profile image
  const uploadProfileImage = async (imageFile) => {
    setLoadingProfileImage(true); // Set loading to true when starting the upload
    const formData = new FormData();
    formData.append("image", imageFile);

    try {
      const res = await axios.post(
        `https://server-side-influencer.onrender.com/brand/uploadbrandimage/${brandId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.data.success) {
        toast.success("Profile image uploaded successfully!");
      } else {
        toast.error("Failed to upload profile image.");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error uploading profile image.");
    } finally {
      setLoadingProfileImage(false); // Set loading to false after the upload is done
    }
  };


  
    const handleDeleteAccount = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This action will delete your account permanently.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });
  
    if (!result.isConfirmed) return;
  
        const brandId = localStorage.getItem("brandID");
  
    if (!brandId || brandId === "null") {
      Swal.fire("Error!", "User ID not found. Please login again.", "error");
      return;
    }
  
    try {
      const response = await fetch(`https://server-side-influencer.onrender.com/brand/deleteaccount/${brandId}`, {
        method: "DELETE",
      });
  
      if (response.ok) {
        await Swal.fire("Deleted!", "Your account has been deleted.", "success");
        localStorage.clear();
        window.location.href = "https://smesh.in/";
      } else {
        Swal.fire("Failed!", "Failed to delete account.", "error");
      }
    } catch (error) {
      console.error("Delete error:", error);
      Swal.fire("Error!", "An error occurred while deleting the account.", "error");
    }
  };
  
  // Function to upload the background imagesss
  const uploadBackgroundImage = async (imageFile) => {
    setLoadingBackgroundImage(true); // Set loading to true when starting the upload
    const formData = new FormData();
    formData.append("image", imageFile);

    try {
      const res = await axios.post(
        `https://server-side-influencer.onrender.com/brand/uploadbrandimages2/${brandId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.data.success) {
        toast.success("Background image uploaded successfully!");
      } else {
        toast.error("Failed to upload background image.");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error uploading background image.");
    } finally {
      setLoadingBackgroundImage(false); // Set loading to false after the upload is done
    }
  };

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true); // Set submitting to true when form is being submitted
    try {
      const updatedData = { ...formData };
      const res = await axios.put(
        `https://server-side-influencer.onrender.com/brand/${brandId}/updateprofile`,
        updatedData
      );
      const data = res.data;
      if (data.success) {
        toast.success(data.message);
        setTimeout(() => {
          navigate("/BrandProfile");
          window.location.reload();
        }, 1500);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to update profile.");
    } finally {
      setSubmitting(false); // Set submitting to false after the form submission is complete
    }
  };

  return (
    <div className="max-w-3xl mx-auto p-6 font-sans">
          <div className="flex items-center justify-between mb-6">
        <div className="flex items-center">
          <button onClick={() => navigate(-1)} className="p-2 text-gray-700">
            <IoMdArrowBack size={24} />
          </button>
          <h1 className="text-2xl font-bold ml-4">Update Brand Profile</h1>
        </div>
        <button
          className="bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700 text-sm ml-12"
      onClick={handleDeleteAccount} >
          Delete Account
        </button>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Username */}
        <div className="flex flex-col">
          <label className="block text-sm font-medium text-gray-700">Username</label>
          <input
            type="text"
            value={formData.uname}
            onChange={(e) => handleChange("uname", e.target.value)}
            className="mt-1 p-2 border rounded-md"
          />
        </div>

        {/* Email */}
        <div className="flex flex-col">
          <label className="block text-sm font-medium text-gray-700">Email</label>
          <input
            type="email"
            value={formData.email}
            onChange={(e) => handleChange("email", e.target.value)}
            className="mt-1 p-2 border rounded-md"
          />
        </div>

        {/* City */}
        <div className="flex flex-col">
          <label className="block text-sm font-medium text-gray-700">City</label>
          <input
            type="text"
            value={formData.city}
            onChange={(e) => handleChange("city", e.target.value)}
            className="mt-1 p-2 border rounded-md"
          />
        </div>

        {/* Country */}
        <div className="flex flex-col">
          <label className="block text-sm font-medium text-gray-700">Country</label>
          <input
            type="text"
            value={formData.country}
            onChange={(e) => handleChange("country", e.target.value)}
            className="mt-1 p-2 border rounded-md"
          />
        </div>

        {/* About */}
        <div className="flex flex-col">
          <label className="block text-sm font-medium text-gray-700">About</label>
          <textarea
            value={formData.about}
            onChange={(e) => handleChange("about", e.target.value)}
            className="mt-1 p-2 border rounded-md"
          />
        </div>

        {/* Shop Name */}
        <div className="flex flex-col">
          <label className="block text-sm font-medium text-gray-700">Shop Name</label>
          <input
            type="text"
            value={formData.shopName}
            onChange={(e) => handleChange("shopName", e.target.value)}
            className="mt-1 p-2 border rounded-md"
          />
        </div>

        {/* Phone */}
        <div className="flex flex-col">
          <label className="block text-sm font-medium text-gray-700">Phone</label>
          <input
            type="text"
            value={formData.phone}
            onChange={(e) => handleChange("phone", e.target.value)}
            className="mt-1 p-2 border rounded-md"
          />
        </div>

        {/* Address */}
        <div className="flex flex-col">
          <label className="block text-sm font-medium text-gray-700">Address</label>
          <input
            type="text"
            value={formData.address}
            onChange={(e) => handleChange("address", e.target.value)}
            className="mt-1 p-2 border rounded-md"
          />
        </div>

        {/* Instagram URL */}
        <div className="flex flex-col">
          <label className="block text-sm font-medium text-gray-700">Instagram URL</label>
          <input
            type="url"
            value={formData.instagramUrl}
            onChange={(e) => handleChange("instagramUrl", e.target.value)}
            className="mt-1 p-2 border rounded-md"
          />
        </div>

        {/* Facebook URL */}
        <div className="flex flex-col">
          <label className="block text-sm font-medium text-gray-700">Facebook URL</label>
          <input
            type="url"
            value={formData.facebookUrl}
            onChange={(e) => handleChange("facebookUrl", e.target.value)}
            className="mt-1 p-2 border rounded-md"
          />
        </div>

        {/* Twitter URL */}
        <div className="flex flex-col">
          <label className="block text-sm font-medium text-gray-700">Twitter URL</label>
          <input
            type="url"
            value={formData.twitterUrl}
            onChange={(e) => handleChange("twitterUrl", e.target.value)}
            className="mt-1 p-2 border rounded-md"
          />
        </div>

        {/* Description */}
        <div className="flex flex-col">
          <label className="block text-sm font-medium text-gray-700">Description</label>
          <textarea
            value={formData.description}
            onChange={(e) => handleChange("description", e.target.value)}
            className="mt-1 p-2 border rounded-md"
          />
        </div>

        {/* Profile Image Upload */}
        <div className="flex flex-col">
          <label className="block text-sm font-medium text-gray-700">Upload Profile Image</label>
          <input
            type="file"
            accept="image/*"
            onChange={handleProfileImageChange}
            className="mt-1 p-2 border rounded-md"
          />
          {loadingProfileImage && <p className="text-gray-500 mt-2">Uploading...</p>} {/* Show loading text */}
        </div>

        {/* Background Image Upload */}
        <div className="flex flex-col">
          <label className="block text-sm font-medium text-gray-700">Upload Background Image</label>
          <input
            type="file"
            accept="image/*"
            onChange={handleBackgroundImageChange}
            className="mt-1 p-2 border rounded-md"
          />
          {loadingBackgroundImage && <p className="text-gray-500 mt-2">Uploading...</p>} {/* Show loading text */}
        </div>

        {/* Submit Button */}
        <button
  type="submit"
  className={`mt-4 text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm p-2 w-full transition ${
    submitting ? 'opacity-50 cursor-not-allowed' : ''
  }`}
  disabled={submitting} // Disable button while submitting
>
  {submitting ? "Submitting..." : "Update Profile"} {/* Change text when submittings*/}
</button>

      </form>
    </div>
  );
};

export default UpdateBrandProfile;
